import React from 'react'
import { sendSocialUser } from '../../actions/socialActions'
import { connect, useDispatch } from 'react-redux'
import iconGoogle from '../../img/google.png';
import ButtonSocial from '../../utils/components/ButtonSocial/ButtonSocial';
import { signFirebase } from '../../config/firebase';

const LoginGoogle = ({ sendSocialUser, history }) => {
    const responseGoogle = (response) => {
        const { googleId } = response;
        console.log();
        sendSocialUser({
            accessToken: response.accessToken,
            idToken: response.idToken,
        }, history, googleId)
    }


    return (
        <div>
            <ButtonSocial
                onClick={() => {
                    signFirebase("google",responseGoogle)

                }}
                icon={iconGoogle} text="Google" />
        </div>

    )
}

export default connect(null, { sendSocialUser })(LoginGoogle)
